<template>
    <b-modal id="campaign-rule-set-conflict-error-modal"
             title="캠페인 규칙셋 충돌 감지"
             hide-footer
             size="xl"
             modal-class="default-modal"
             @hide="hideModal"
    >
        <template v-if="errorData">
            <b-alert variant="info" show>
                <h6 class="alert-heading">새로운 규칙셋이 기존 캠페인 규칙셋들과 충돌합니다.</h6>
                <p class="mb-0">{{ errorData.suggested_action }}</p>
            </b-alert>

            <div v-if="errorData.conflicts && errorData.conflicts.length > 0">
                <h6 class="mb-3">충돌 상세 내역:</h6>

                <b-alert variant="warning" show>
                    <strong>총 {{ errorData.conflict_count }}개의 충돌이 감지되었습니다.</strong>
                </b-alert>

                <b-card v-for="(conflict, index) in errorData.conflicts" :key="index" class="mb-3">
                    <b-card-body>
                        <h5>충돌 {{ index + 1 }}</h5>
                        <p class="text-muted">{{ conflict.message }}</p>

                        <div class="p-3 rounded" style="background-color: #fff9e6;">
                            <strong>충돌 예시:</strong>
                            <pre class="conflict-example-box">{{ formatJson(conflict.conflict_example) }}</pre>
                        </div>

                        <div class="mt-3 text-secondary small">
                            기존 규칙셋 ID: {{ conflict.existing_rule_set_id }} | 캠페인 ID: {{ conflict.existing_campaign_id }}
                        </div>
                    </b-card-body>
                </b-card>

                <b-alert variant="success" show class="mt-4">
                    <div class="d-flex align-items-start">
                        <b-icon-check-circle-fill class="mr-2 flex-shrink-0"
                                                  style="margin-top: 3px;"></b-icon-check-circle-fill>
                        <div>
                            <h6 class="alert-heading">해결 방안</h6>
                            {{ errorData.suggested_action }}
                        </div>
                    </div>
                </b-alert>
            </div>
        </template>


    </b-modal>
</template>

<script>
export default {
    name: 'CampaignRuleSetErrorModal',
    props: {
        // 부모 컴포넌트로부터 API 에러 응답 데이터를 prop으로 받습니다.
        errorData: {
            type: [Object, null],
            default: null,
        }
    },
    methods: {
        // JSON 객체를 보기 좋게 포맷팅하는 헬퍼 메소드
        formatJson(obj) {
            if (!obj) return '';
            // JSON.stringify의 세 번째 인자는 들여쓰기(indentation) 크기입니다.
            return JSON.stringify(obj, null, 2);
        },
        hideModal() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
// 충돌 예시를 보여주는 pre 태그 스타일
.conflict-example-box {
    background-color: #fffbeb;
    border: 1px solid #ffeeba;
    border-radius: 4px;
    padding: 0.75rem;
    margin-top: 0.5rem;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 0.875em;
    white-space: pre-wrap;
    word-break: break-all;
}
</style>
